module.exports = __webpack_public_path__ + "static/media/iconLogoWhite.0d394c83.svg";